<template>
  <div class="flex border-b border-gray-700 mb-4">
    <button
      @click="$emit('change-tab', 'products')"
      class="px-6 py-3 text-sm font-medium transition-colors relative -mb-px"
      :class="[
        activeTab === 'products'
          ? 'text-blue-400 border-b-2 border-blue-400'
          : 'text-gray-400 hover:text-gray-300',
      ]"
    >
      Oglasi
    </button>
    <button
      @click="$emit('change-tab', 'ratings')"
      class="px-6 py-3 text-sm font-medium transition-colors relative -mb-px"
      :class="[
        activeTab === 'ratings'
          ? 'text-blue-400 border-b-2 border-blue-400'
          : 'text-gray-400 hover:text-gray-300',
      ]"
    >
      Ocene
    </button>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'ProfileTabs',
  props: {
    activeTab: {
      type: String,
      required: true,
    },
  },
  emits: ['change-tab'],
});
</script>
